import React from 'react';
import { Controller } from 'react-hook-form';
import { FormFeedback, Input, Label } from 'reactstrap';

const InputInternationalPhone = ({
  label,
  options,
  control,
  errors
}) => {
  return (
    <React.Fragment>
      <Label className="form-label" for={options.id}>
        {label}
      </Label>
      <Controller
        id={options.id}
        name={options.name}
        control={control}
        render={({ field }) => (
          <Input
            invalid={errors[options.name] && true}
            {...field}
            placeholder=""
            type="tel"
            disabled={options?.disabled}
            onChange={(e) => {
              const value = e.target.value;
              // Permitir solo números y el símbolo +
              const formattedValue = value.replace(/[^0-9+]/g, '');
              // Si empieza con 0 o tiene más de un símbolo +
              if ((formattedValue[0] === '0') || (formattedValue.split('+').length - 1 > 1)) return;
              field.onChange(formattedValue);
            }}
          />
        )}
      />
      {errors[options.name] && (
        <FormFeedback>{errors[options.name]?.message}</FormFeedback>
      )}
    </React.Fragment>
  );
};

export default InputInternationalPhone;